import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const deleteDevice = async (payload: number) => {
  const response = await axios.delete(`${getAPIService}/v2/api/ip-devices/devices/${payload}`)
  return response.data
}
